'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$20() {
  this.bfC = null;
  this.bfA = null;
  this.bfB = false;
  this.bfy = null;
  this.bfz = false;
  this.bfD = false;
  this.bfE = false;
  this.bfC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$20 as $c_Lpresto_PrestoRouter$$anon$20 };
$p = $c_Lpresto_PrestoRouter$$anon$20.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$20;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$20() {
}
export { $h_Lpresto_PrestoRouter$$anon$20 as $h_Lpresto_PrestoRouter$$anon$20 };
$h_Lpresto_PrestoRouter$$anon$20.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bfC;
});
$p.t = (function() {
  if ((!this.bfB)) {
    this.bfA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bfB = true;
  }
  return this.bfA;
});
$p.ae = (function() {
  if ((!this.bfz)) {
    this.bfy = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bfz = true;
  }
  return this.bfy;
});
$p.w = (function() {
  if ((!this.bfE)) {
    this.bfD = false;
    this.bfE = true;
  }
  return this.bfD;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$20 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$20, "presto.PrestoRouter$$anon$20", ({
  NK: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$20 as $d_Lpresto_PrestoRouter$$anon$20 };
//# sourceMappingURL=presto.-Presto-Router$$anon$20.js.map
